import { useState } from "react";
import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import ChatInterface from "@/components/ChatInterface";
import ResizableChatPanel from "@/components/ResizableChatPanel";
import { useIsCompact } from "@/hooks/use-mobile";
import type { ChartContextSource } from "@/analytics/charts/chart.context";

interface ChatDockProps {
  chartItems: ChartContextSource[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
}


export function ChatDock({ chartItems, open, onOpenChange }: ChatDockProps) {
  const isCompact = useIsCompact();
  const [overlayOpen, setOverlayOpen] = useState(false);

  if (isCompact) {
    return (
      <>
        {!overlayOpen && (
          <Button
            size="icon"
            title="Open Prism Ask"
            aria-label="Open Prism Ask"
            onClick={() => setOverlayOpen(true)}
            className="fixed bottom-4 right-4 z-30 h-12 w-12 rounded-full shadow-lg"
          >
            <MessageSquare className="h-5 w-5" />
          </Button>
        )}

        {overlayOpen && (
          <div className="pb-safe fixed inset-0 z-50 flex flex-col bg-background p-2">
            <ChatInterface onClose={() => setOverlayOpen(false)} chartItems={chartItems} />
          </div>
        )}
      </>
    );
  }

  return open ? (
    <ResizableChatPanel>
      <ChatInterface onClose={() => onOpenChange(false)} chartItems={chartItems} />
    </ResizableChatPanel>
  ) : (
    <div className="border-l bg-background p-2 flex flex-col items-center">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onOpenChange(true)}
        title="Open Prism Ask"
        aria-label="Open Prism Ask"
      >
        <MessageSquare className="h-5 w-5" />
      </Button>
    </div>
  );
}

export default ChatDock;
